export enum QuestionnaireName {
    osasEss = 'osasEss',
    osasHsdq = 'osasHsdq',
}

export const questionsPerQuestionnaireStep = {
    [QuestionnaireName.osasEss]: 4,
    [QuestionnaireName.osasHsdq]: 5,
};
